
function xor(a, b) {
    return a ? !b : b;
}

export default xor;